// The blueprint family as the console speaks it: the library's module
// (impire-sdk-js blueprint, mirroring impire-sdk-go/blueprint), re-exported
// so that every surface builds the family's subjects in one place
// (02-DESIGN/13-blueprints/01-the-blueprint.md § subjects).

import { blueprint } from "@impire-io/sdk";

export const SERVICE = blueprint.SERVICE;
export const Code = blueprint.Code;
export type Entry = blueprint.Entry;
export type Document = blueprint.Document;
export type Report = blueprint.Report;
export type StatusReply = blueprint.StatusReply;
export type ChildRow = blueprint.ChildRow;
export type ChildrenReply = blueprint.ChildrenReply;
export type HistoryReply = blueprint.HistoryReply;
export type Secret = blueprint.Secret;
export type SecretSlot = blueprint.SecretSlot;
export type LibraryDocument = blueprint.LibraryDocument;
export type LibraryRow = blueprint.LibraryRow;
export type LibraryReply = blueprint.LibraryReply;
export type AssignRequest = blueprint.AssignRequest;
export const validName = blueprint.validName;
export const slotOf = blueprint.slotOf;
export const MAX_LIBRARY = blueprint.MAX_LIBRARY;

/**
 * The subjects the console's pages speak. A parent writes a child's
 * document only by assigning one of its named blueprints (01-the-blueprint.md
 * § named blueprints; decision 0052).
 */
export const Subjects = {
  assign: (child: string) => blueprint.assignSubject(child),
  libraryList: () => blueprint.libraryList(),
  librarySet: (name: string) => blueprint.librarySubject(name, blueprint.Verb.set),
  libraryGet: (name: string) => blueprint.librarySubject(name, blueprint.Verb.get),
  libraryHistory: (name: string) => blueprint.librarySubject(name, blueprint.Verb.history),
  libraryDelete: (name: string) => blueprint.librarySubject(name, blueprint.Verb.delete),
  get: (child: string) => blueprint.childSubject(child, blueprint.Verb.get),
  history: (child: string) => blueprint.childSubject(child, blueprint.Verb.history),
  delete: (child: string) => blueprint.childSubject(child, blueprint.Verb.delete),
  status: (child: string) => blueprint.childSubject(child, blueprint.Verb.status),
  children: () => blueprint.childrenSubject(),
  ownGet: () => blueprint.ownGet(),
  ownStatus: () => blueprint.ownStatus(),
} as const;

export const EXPECT_REVISION_HEADER = blueprint.EXPECT_REVISION_HEADER;
